import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import FontAwesome from "react-fontawesome";
import {
	serviceCategoriesLoaded,
	serviceCategoriesLoading,
} from "../../actions";
import { serviceActions } from "../../webapi";
import { Button } from "../../components";
import ServiceCategoriesList from "./ServiceCategoriesList";
import AddCategoryModal from "./AddCategoryModal";

class ServiceCategories extends Component {
	state = {
		loading: false,
		modalOpen: false,
		editingCategory: null,
	};

	componentDidMount() {
		this.getCategories();
	}

	getCategories = () => {
		this.setState({ loading: true });
		this.props.serviceCategoriesLoading();
		serviceActions
			.getServiceCategories(this.props.auth.site)
			.then((res) => {
				const categories = res.data && res.data.Items ? res.data.Items : [];
				const sorted = _.sortBy(categories, "Order");
				this.props.serviceCategoriesLoaded(sorted);
				this.setState({ loading: false });
			})
			.catch((error) => {
				this.setState({ loading: false });
				console.log("Failed to load service categories", error);
			});
	};

	handleAdd = () => {
		this.setState({ modalOpen: true, editingCategory: null });
	};

	handleEdit = (category) => {
		this.setState({ modalOpen: true, editingCategory: category });
	};

	handleModalClose = () => {
		this.setState({ modalOpen: false, editingCategory: null });
	};

	handleModalSave = (name) => {
		const { editingCategory } = this.state;
		const request = editingCategory
			? serviceActions.editServiceCategory(editingCategory.RowId, name)
			: serviceActions.addServiceCategory(this.props.auth.site, name);

		return request
			.then(() => {
				this.handleModalClose();
				this.getCategories();
			})
			.catch((error) => {
				alert("Something went wrong. Please try again.");
				throw error;
			});
	};

	handleDelete = (category) => {
		if (window.confirm(`Are you sure you want to delete "${category.Name}"?`)) {
			serviceActions
				.deleteServiceCategory(category.RowId)
				.then((res) => {
					this.getCategories();
				})
				.catch((error) => {
					alert("Something went wrong. Please try again.");
				});
		}
	};

	handleReorder = (reorderedCategories) => {
		this.props.serviceCategoriesLoaded(reorderedCategories);
		const categories = reorderedCategories.map((cat, index) => ({
			id: cat.RowId,
			order: index,
		}));
		serviceActions
			.reorderServiceCategories(this.props.auth.site, categories)
			.then((res) => {
				this.getCategories();
			})
			.catch((error) => {
				alert("Something went wrong with reordering. Please try again.");
				this.getCategories();
			});
	};

	render() {
		const { loading } = this.state;
		const { categories } = this.props;
		return (
			<div style={{ minWidth: "100%" }} className="feature-infopage">
				<div className="infopage__container">
					<div className="infopage__header">
						<div className="header__text">
							<h1 className="text-h1">Service Categories</h1>
							<p className="text-h2">
								Manage and reorder the categories that services and sponsors can
								be assigned to. Drag to reorder.
							</p>
						</div>
						<div className="header__actions">
							<Button
								buttonType="primary"
								isActive
								onClick={this.handleAdd}
								leftIcon="plus-circle"
							>
								Add Category
							</Button>
						</div>
					</div>
					{loading ? (
						<div className="infopage__loading">
							<FontAwesome name="spinner" spin style={{ fontSize: 32 }} />
							<p>Loading categories...</p>
						</div>
					) : (
						<ServiceCategoriesList
							categories={categories}
							onEdit={this.handleEdit}
							onDelete={this.handleDelete}
							onReorder={this.handleReorder}
						/>
					)}
				</div>
				<AddCategoryModal
					isOpen={this.state.modalOpen}
					onClose={this.handleModalClose}
					onSave={this.handleModalSave}
					initialName={
						this.state.editingCategory ? this.state.editingCategory.Name : ""
					}
				/>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	const { serviceCategories: categories } = state.services;
	const { auth } = state;
	return {
		categories,
		auth,
	};
};

export default connect(mapStateToProps, {
	serviceCategoriesLoaded,
	serviceCategoriesLoading,
})(ServiceCategories);
